import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=841180d2&"
import script from "./Tab.vue?vue&type=script&lang=ts&"
export * from "./Tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports